import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryGrid } from './components/CategoryGrid';
import { Newsletter } from './components/Newsletter';
import { AboutSection } from './components/AboutSection';
import { Founder } from './components/Founder';
import { Footer } from './components/Footer';
import { Location } from './components/Location';
import { Lookbook } from './pages/Lookbook';
import { LookbookDetail } from './pages/LookbookDetail';
import { About } from './pages/About';
import { Collection } from './pages/Collection';
import { Booking } from './pages/Booking';
function Home() {
  return <main className="flex-grow" data-id="element-0">
      <Hero data-id="element-1" />
      <Newsletter data-id="element-2" />
      <AboutSection data-id="element-3" />
      <CategoryGrid data-id="element-4" />
      <Location data-id="element-5" />
    </main>;
}
export function App() {
  return <Router data-id="element-6">
      <div className="min-h-screen flex flex-col selection:bg-black selection:text-white" data-id="element-7">
        <Header data-id="element-8" />
        <Routes data-id="element-9">
          <Route path="/" element={<Home data-id="element-11" />} data-id="element-10" />
          <Route path="/lookbook" element={<Lookbook data-id="element-13" />} data-id="element-12" />
          <Route path="/lookbook/:id" element={<LookbookDetail data-id="element-15" />} data-id="element-14" />
          <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
          <Route path="/collection/:category" element={<Collection data-id="element-19" />} data-id="element-18" />
          <Route path="/booking" element={<Booking data-id="element-21" />} data-id="element-20" />
        </Routes>
        <Footer data-id="element-22" />
      </div>
    </Router>;
}